// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3bEhA","legacyBtn":"MutateMid_legacyBtn__3f-84"};